import { useState, useEffect } from 'react';
import './TopNav.css';
import { useNavigate } from 'react-router-dom';
import { useAdminContext } from '../../context/AdminContext';

const TopNav = () => {
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [toggling, setToggling] = useState(false); // ⏳ to prevent rapid toggles
  const navigate = useNavigate();

  const {
    admin,
    AdminLogout,
    popupEnabled,
    setPopupEnabled,       
    fetchPopupStatus,
    togglePopupStatus
  } = useAdminContext();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Load popup status on mount
  useEffect(() => {
    fetchPopupStatus();
  }, []);

  const handleLogout = () => {
    AdminLogout();
    navigate('/admin/login');
  };

  const handleToggle = async () => {
    if (toggling) return;
    setToggling(true);

    const newStatus = !popupEnabled;
    setPopupEnabled(newStatus);         // ✅ update UI instantly
    await togglePopupStatus(newStatus); // 🔄 update Firestore in background

    setToggling(false);
  };

  return (
    <header className="admin-topnav">
      <div className="admin-topnav-left">
        <h1 className="brand-name">Spicescript.com</h1>
      </div>

      <div className="admin-topnav-right">
        {/* <div className="toggle-container">
          <label className="switch">
            <input
              type="checkbox"
              checked={popupEnabled}
              onChange={handleToggle}
              disabled={toggling} 
            />
            <span className="slider round"></span>
          </label>
          <span className="toggle-label">
            Popup: {popupEnabled ? 'ON' : 'OFF'}
          </span>
        </div> */}

        <span className="welcome">Welcome, Admin</span>
        <span className="clock">{currentTime}</span>
        <span className="welcome">{admin}</span>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
};

export default TopNav;
